<template>
  <div id="main">
    <div class="store-content item mt-24">
      <div class="item-box">
        <div class="gallery-wrapper">
          <div class="gallery">
            <div class="thumb">
              <ul>
                <li class="on">
                  <img :src="itemData.img" style="width: 450px; height: 450px; object-fit: cover" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="banner">
          <div class="sku-custom-title">
            <div class="params-price">
              <span><em>¥</em><i>{{ itemData.price }}</i></span>
            </div>
            <div class="params-info">
              <h4>{{ itemData.title }}</h4>
              <h6>{{ itemData.info }}</h6>
            </div>
          </div>
          <div class="sku-dynamic-params-panel">
            <div class="sku-dynamic-params clear">
              <div class="params-name">数量</div>
              <div class="params-detail clear">
                <div class="item-num js-select-quantity">
                  <!--  down-disabled -->
                  <span class="down" :class="{ 'down-disabled': itemCount <= 1 }" @click="subCount">-</span>
                  <span class="num">{{ itemCount }}</span>
                  <!-- up-disabled -->
                  <span class="up" @click="addCount()">+</span>
                </div>
              </div>
            </div>
          </div>
          <div class="sku-status">
            <div class="cart-operation-wrapper clearfix">
              <span class="blue-title-btn js-add-cart" @click="addCarPanel(itemData)"><a>加入购物车</a></span>
              <span class="gray-title-btn" @click="addCarPanelAndGo(itemData)"><a>现在购买</a></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/item.css";
import itemsData from "@/lib/newItemsData.js";
export default {
  data() {
    return {
      itemData: JSON.parse(this.$route.query.itemData),
      itemsData,
      imgIndex: 0,
      itemCount: 1,
    };
  },
  computed: {
    itemInfo() {
      var goods = this.itemsData.filter((item) => {
        return item.sku_id == this.itemId;
      });
      return goods[0];
    },
  },
  created() {
    this.itemData = JSON.parse(this.$route.query.itemData);
  },
  watch: {
    "$route.query.itemId"(newVal) {
      this.itemId = newVal;
    },
  },
  methods: {
    tableImg(index) {
      this.imgIndex = index;
    },
    //商品数量加1
    addCount() {
      this.itemCount++;
    },
    //商品数量减1
    subCount() {
      if (this.itemCount > 1) {
        this.itemCount--;
      }
    },
    addCarPanel(data) {
      this.$store.commit("addCarPanelData", {
        info: data,
        count: this.itemCount,
      });
    },
    addCarPanelAndGo(data) {
      this.$router.push('/cart')
      this.$store.commit("addCarPanelData", {
        info: data,
        count: this.itemCount,
      });

    },
  },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/item.vue